import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core'
import { TextField, Button } from '@prototype'
import Table from '@tables/table'

const initialState = {
    name: '',
    startAt: '',
    endAt: '',
    dialogOpen: false,
}

const COMPONENT_GROUP = 'event_prize';

class EventPrizeDetailRedPacketDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EventPrizeDetailRedPacketDialog', options)
        }
        this.state = initialState
    }

    redPacketColumns = [
        { field: 'pf_sub_pf_id' },
        { field: 'pf_account' },
        { field: 'origin_account' },
        { field: 'id' },
        { field: 'pay_money', title: utils.t('award', 'EventPrizeDetailRedPacketDialog'), type: 'currency' },
        { field: 'money', type: 'currency' },
        { field: 'gacha_at', type: 'datetime' },
        { field: 'issued_at', type: 'datetime' },
        { field: 'sent_by' },
    ]

    options = {
        export: false
    }

    componentDidMount() {
        this.props.onRef(this)
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(rowData) {
        this.setState({
            name: rowData['name'],
            currency: rowData['currency'],
            startAt: rowData['start_at'],
            endAt: rowData['end_at'],
            dialogOpen: true,
        })
        utils.apiRequest(
            'get',
            API.RED_PACKET_GACHA,
            {
                event_id: rowData['event_id'],
            },
            (gacha) => {
                const gachaData = gacha.map((item) => {
                    item.id = item.pf_account ? item.id : ''
                    item.sent_by = item.pf_account ? this.t('system') : ''
                    item.pay_money = item.consume_points * utils.getCurrencyRate(rowData.currency)
                    item.money = item.bonus * utils.getCurrencyRate(rowData.currency)
                    item.pf_sub_pf_id = item.pf_sub_pf_id ? utils.getSubPlatformName(item.pf_sub_pf_id) : ''
                    item.gacha_at = item.pf_account ? item.gacha_at : ''
                    item.issued_at = item.pf_account ? item.issued_at : ''
                    return item
                })  
                this.updateTableColumnTitle(rowData.currency)
                this.redPacketTable.SetData(gachaData)
            },
            (error) => {
                console.log(error);
            },
            true
        )
    }

    updateTableColumnTitle() {
        this.redPacketColumns.find((elem) => elem.field === 'money').title = this.t('money', { currency: `(${this.t('gameCurrency')})` })
        this.redPacketTable.setColumns()
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} fullWidth maxWidth="lg">
                <DialogTitle>{this.t('view')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField className={this.props.classes.textField} readOnly label={this.t('name')} value={this.state.name} />
                            <TextField
                                className={this.props.classes.textField}
                                readOnly
                                label={this.t('currency')}
                                value={this.t(`Currency.${this.state.currency}`)}
                            />
                            <TextField
                                className={this.props.classes.dateRangeTextField}
                                readOnly
                                label={this.t('datetimeRange')}
                                value={`${utils.unixToDateTime(this.state.startAt)} ~ ${utils.unixToDateTime(this.state.endAt)}`}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Table
                                ownerName="EventPrizeDetailRedPacketDialog"
                                columns={this.redPacketColumns}
                                options={{ export: this.options.export, orderDirection: 'desc' }}
                                onRef={(ref) => (this.redPacketTable = ref)}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button value={this.t('confirm')} onClick={() => this.closeDialog()} />
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        select: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        dateRangeTextField: {
            margin: theme.spacing(1),
            width: '360px',
        },
    }
}

EventPrizeDetailRedPacketDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EventPrizeDetailRedPacketDialog)
